import React, { useState, useEffect } from 'react';
import DocList from '../../../components/UploadDocs/DocList';
import GuideBar from '../../../components/UploadDocs/DocHeadingGuidline';
import SelfiIcon from '../../../images/icons/selfie.svg';
import CreditScore from '../../../images/icons/credit_score.svg';
import AddressCard from '../../../components/AddressCards/AddressCards';
import root from 'window-or-global';
import './KYCGuider.css';
import { UserKycStatus } from '../../../common/userData/UserKycStatus';
//import { resolveFieldValueOrError } from '../../../../../../../../../Library/Caches/typescript/3.7/node_modules/graphql/execution/execute';

const KYCContainer = props => {
  const [selectedAddressCard, setSelectedAddressCard] = useState('');
  const [addressType, setAddressType] = useState('');
  const [kycStatus, setKycStatus] = useState({
    pan: 'NOT_INITIATED',
    aadhar: 'NOT_INITIATED',
    address: 'NOT_INITIATED',
    selfie: 'NOT_INITIATED',
    bank: 'NOT_INITIATED',
    ref: 'NOT_INITIATED',
    custom: false
  });

  let custom_display, reg_display;
  if (kycStatus.custom) {
    custom_display = 'block w-full  md:w-1/4 lg:1/4 mt-24 md:hidden';
    reg_display = 'hidden';
  } else {
    custom_display = 'hidden';
    reg_display = 'block w-full  md:w-1/4 lg:1/4 md:hidden';
  }
  if (kycStatus.custom === 'null') {
    custom_display = 'hidden';
    reg_display = 'hidden';
  }

  const onclick_handler = (a = null) => {
    if (props.onclick_handler) return props.onclick_handler(a);
    return null;
  };

  // fetching KycStatus
  // const kycStatus
  useEffect(() => {
    UserKycStatus().then(res => {
      setKycStatus(res);
    });
  }, []);

  // const kycStatus =await processDataAsycn();

  let curr_page = props.curr_page;

  if (kycStatus) {
    return (
      <div className="w-full -mt-10 bg-white md:bg-grey-950 pb-4">
        <div className="w-full" id="doc_container"></div>
        <div className="w-full block text-center   md:mt-20">
          <h2 className="text-2xl font-khand font-semibold">
            {props.guideName === 'Profile' ? 'USER PROFILE' : 'KYC PROCESS'}
          </h2>
        </div>

        <div className="block w-full md:flex">
          {/* For Mobile */}
          <div className={reg_display} id="mobile_doc_list">
            <div className="w-4/5 mr-auto block md:hidden px-3 text-left mt-20">
              <p className="font-roboto font-normal text-sm text-orange-600 opacity-100">
                Please keep the following document ready for completing your
                e-kyc
              </p>
            </div>

            <DocList
              doc={{
                name: 'PAN Card',
                verified: kycStatus.pan,
                val_init: 'A',
                id: 'pan'
              }}
              click={() => onclick_handler('pan')}
            />
            <DocList
              doc={{
                name: 'Credit Score',
                verified: kycStatus.credit,
                val_init: 'B',
                DocIcon: CreditScore,
                opacity: '0.2',
                id: 'credit'
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'ADDRESS PROOF',
                verified: kycStatus.address,
                val_init: 'C',
                DocIcon: CreditScore,
                opacity: '0.2',
                id: 'address'
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'Face Verification : Selfie',
                verified: kycStatus.selfie,
                val_init: 'D',
                DocIcon: SelfiIcon,
                opacity: '0.2',
                id: 'selfie'
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'Bank Details',
                verified: kycStatus.selfie,
                val_init: 'D',
                DocIcon: SelfiIcon,
                opacity: '0.2',
                id: 'bank_details'
              }}
              click={onclick_handler}
            />
          </div>
          <div className={custom_display} id="mobile_custom_list">
            {/* <DocList
              doc={{
                name: props.data.custom,
                verified: data.custom_status,
                val_init: 'A',
                id: 'voter_card'
              }}
              click={onclick_handler}
            /> */}
          </div>

          {/* For WEB */}
          <div
            className="hidden w-full  md:w-4/12 lg:1/4 md:block  pl-6"
            id="web_doc_list"
          >
            {props.kycStep == 10 ? (
              <DocList
                doc={{
                  name: 'General Details',
                  verified: kycStatus.pan,
                  id: 'web_pan',
                  curent_page: curr_page.general
                }}
                click={onclick_handler}
              />
            ) : null}
            <DocList
              doc={{
                name: 'PAN Card',
                verified: kycStatus.pan,
                id: 'web_pan',
                curent_page: curr_page.pan
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'ADDRESS PROOF',
                verified: kycStatus.address,
                id: 'web_address',
                curent_page: curr_page.address
              }}
              click={onclick_handler}
            />
            {/* {props.showAddress ? (
              <AddressCard
                selectedAddressCard={selectedAddressCard}
                onChange={setSelectedAddressCard}
              />
            ) : null} */}
            <DocList
              doc={{
                name: 'SELFIE',
                verified: kycStatus.selfie,
                id: 'web_selfie',
                curent_page: curr_page.selfie
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'BANK DETAILS',
                verified: kycStatus.bank,
                id: 'web_bank_details',
                curent_page: curr_page.bank
              }}
              click={onclick_handler}
            />
            <DocList
              doc={{
                name: 'REFERENCES',
                verified: kycStatus.ref,
                id: 'web_reference',
                curent_page: curr_page.ref
              }}
              click={onclick_handler}
            />
          </div>

          {/* Docuent Container */}
          <div className="w-full px-2 block md:flex md:w-3/5 mx-auto bg-white  md:pb-0 rounded-lg  md:mt-5 md:-ml-5 z-10">
            <props.container
              selectedAddressCard={selectedAddressCard}
              onChange={setSelectedAddressCard}
              changeAddressType={setAddressType}
              // componentHandler={props.componentHandler}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return <div>Loading ...</div>;
  }
};
export default KYCContainer;
